import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { MessagePreviewListItem } from './MessagePreviewListItem';

export class MessagePreviewList extends React.Component {

    render() {
        const {
            messages,
        } = this.props;

        if ( messages.length === 0 ) {
            return (
                <ul className="menu">
                    <li>
                        <h4 className="text-center m-t-15 m-b-15">
                            {I18nUtils.tr('TR_NO_TIENES_MENSAJES')}
                        </h4>
                    </li>
                </ul>
            );
        }

        return (
            <ul className="menu message-menu">
                {
                    messages.map((message) =>
                        <MessagePreviewListItem
                            key={message.id()}
                            message={message}
                        />
                    )
                }
            </ul>
        );
    }
}

MessagePreviewList.propTypes = {
    messages: PropTypes.array.isRequired,
};

MessagePreviewList.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/preview-list/MessagePreviewList.jsx